import React from 'react'

import BaseSelect, { Props as BaseProps } from './base'

export interface Props<T> extends Omit<BaseProps<T>, 'value' | 'onSelect' | 'multiple'> {
  value?: T[]
  onSelect?: (value: T[]) => void
  // searchable?: boolean; TODO Searchable for muliple select is not supported yet
}
const MultipleSelect = (props: Props<any>) => {
  return <BaseSelect multiple {...props} />
}

MultipleSelect.Skeleton = BaseSelect.Skeleton

export default MultipleSelect
